import { render, staticRenderFns } from "./singleAddition.vue?vue&type=template&id=1f6e9c6d&scoped=true"
import script from "./singleAddition.vue?vue&type=script&lang=js"
export * from "./singleAddition.vue?vue&type=script&lang=js"
import style0 from "./singleAddition.vue?vue&type=style&index=0&id=1f6e9c6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e9c6d",
  null
  
)

export default component.exports